module.exports = __webpack_public_path__ + "media/images/about/ac_7-f568447f3fb3c4c476fad89e5c5ef4fd.jpg";